import { getContext } from "svelte";
import type { Tenant } from "../../core/schema/Tenant.js";
import { tenantContextKey } from "./contexts/tenantContextKey.js";

export function getTenant(): Tenant {
	return getContext<Tenant>(tenantContextKey);
}
